import type { Icon } from 'ngxi'

import { Directive, input } from '@angular/core'

import { Ngxi } from 'ngxi'

@Directive({
  standalone: true,
  selector: 'svg[ngxiLineicons]',
  hostDirectives: [
    {
      directive: Ngxi,
      inputs: ['icon:ngxiLineicons', 'width', 'height', 'viewBox'],
    },
  ],
})
export class NgxiLineicons {
  readonly ngxiLineicons = input.required<Icon>()
}
